<template>
  <div class="col-4">
    <div class="card p-3">
      <table class="table table-striped">
        <tbody>
          <tr>
            <th>{{ translations.transaction_count_unfinished }}</th>
            <td>{{ transactions }}</td>
          </tr>
          <tr>
            <th>{{ translations.connected_charge_points }}</th>
            <td>{{ connected }}</td>
          </tr>
          <tr>
            <th>{{ translations.disconnected_charge_points }}</th>
            <td>{{ notConnected }}</td>
          </tr>
          <tr>
            <th>{{ translations.last_message_received }}</th>
            <td>{{ lastMessageReceived }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card p-3" v-if="adminConnected != null">
      <div class="card-header">
        <div class="card-title">Total Count For Admins</div>
      </div>
      <div class="card-body">
        <div class="card-text">
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>{{ translations.transaction_count_unfinished }}</th>
                <td>{{ adminTransactions }}</td>
              </tr>
              <tr>
                <th>{{ translations.connected_charge_points }}</th>
                <td>{{ adminConnected }}</td>
              </tr>
              <tr>
                <th>{{ translations.disconnected_charge_points }}</th>
                <td>{{ adminNotConnected }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card p-3">
      <div class="card-header">
        <div class="card-title">Find EVSE</div>
      </div>
      <div class="card-body">
        <div class="card-text">
          <div class="form-group">
            <label for="evse-prefix">Enter Hubject EVSE id:</label>
            <input
              @change="getEvseIds"
              class="form-control"
              list="evse-list"
              id="evse-prefix"
              name="evse-prefix"
              v-model="evseIdModel"
            />
            <datalist id="evse-list" :key="evsePrefix || 'empty'">
              <option v-for="evseId in evseIds" :value="evseId"></option>
            </datalist>
          </div>
          <div class="form-group">
            <input type="checkbox" id="showClusters" :checked="showClusters" @change="$emit('toggleShowClusters')" />
            <label style="margin-left: 10px" for="showClusters">Show Hubject Clusters</label>
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-primary" @click="$emit('resetClick')">{{ translations.center_map }}</button>
  </div>
</template>
<script>
export default {
  props: ['translations', 'getEvseListRoute', 'showClusters'],
  emits: ['getEvseCoordinates', 'resetClick', 'toggleShowClusters'],
  data: function () {
    return {
      connected: null,
      notConnected: null,
      transactions: null,
      message: null,
      adminConnected: null,
      adminNotConnected: null,
      adminTransactions: null,
      adminMessage: null,
      lastMessageReceived: null,
      evseIds: [],
      evseObject: {},
      evseIdModel: '',
      evsePrefix: null,
      pendingPrefix: null,
    };
  },
  watch: {
    evseIdModel() {
      this.getEvseIds();
    },
  },
  methods: {
    resetEvseCache() {
      this.evseIds = [];
      this.evseObject = {};
      this.evsePrefix = null;
      this.pendingPrefix = null;
    },
    tryEmitCoordinates() {
      const coords = this.evseObject[this.evseIdModel];
      if (coords) {
        this.$emit('getEvseCoordinates', coords);
      }
    },
    getData: function () {
      axios
        .get('/get-data')
        .then((response) => {
          this.connected = response.data.connected;
          this.notConnected = response.data.notConnected;
          this.transactions = response.data.transactions;
          this.message = response.data.message;
          this.adminConnected = response.data.adminConnected;
          this.adminNotConnected = response.data.adminNotConnected;
          this.adminTransactions = response.data.adminTransactions;
          this.adminMessage = response.data.adminMessage;
          this.lastMessageReceived = response.data.lastMessageReceived;
          this.error = '';
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.error = error.response.data.error;
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
        });
    },
    getEvseIds: function () {
      if (!this.evseIdModel || this.evseIdModel.length < 6) {
        this.resetEvseCache();
        return;
      }

      const prefix = this.evseIdModel.substring(0, 6);

      if (this.evsePrefix === prefix && this.evseIds.length) {
        this.tryEmitCoordinates();
        return;
      }

      if (this.pendingPrefix === prefix) {
        return;
      }

      this.evseIds = [];
      this.evseObject = {};
      this.evsePrefix = prefix;
      this.pendingPrefix = prefix;

      const requestPrefix = prefix;

      axios
        .get(this.getEvseListRoute + '?prefix=' + requestPrefix)
        .then((response) => {
          if (this.pendingPrefix === requestPrefix) {
            this.pendingPrefix = null;
          }

          if (this.evseIdModel.substring(0, 6) !== requestPrefix) {
            return;
          }

          this.evseIds = Object.keys(response.data.data);
          this.evseObject = response.data.data;
          this.tryEmitCoordinates();
        })
        .catch((error) => {
          if (this.pendingPrefix === requestPrefix) {
            this.pendingPrefix = null;
          }

          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.error = error.response.data.error;
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
        });
    },
  },
  mounted() {
    window.setInterval(() => this.getData(), 10000);
    this.getData();
  },
};
</script>
